<div
  class="landing"
  *transloco="let t">
  <div class="register-user-new">
    <div class="register-user-new_form">
      <app-company-logo [width]="200" />
      <div class="register-user-new_inner">
        <h2 class="register-user-new_title">
          {{ t('registration-new.invitation-sent.check-your-email') }}
        </h2>
        <div
          class="register-user-new_email"
          [innerHTML]="t('registration-new.invitation-sent.open-and-confirm', { email: email() })"></div>
        @if (emailVendor()) {
          <a
            [href]="emailVendor().url"
            target="_blank"
            rel="noopener noreferrer"
            class="btn register-user-new_button register-user-new_button-outline">
            <ng-container *ngComponentOutlet="emailVendor().iconComponent" />
            {{ t('registration-new.email-sent.open') }}
            {{ t('registration-new.email-sent.vendor.' + emailVendor().id) }}
          </a>
        }
      </div>
      <div class="layout_footer">
        <app-legal-terms-footer />
      </div>
    </div>
    <div appBackgroundBranded></div>
  </div>
</div>
